<template>
  <v-container fluid fill-height>
    <v-snackbar
      v-model="snackbar"
      multi-line
      :timeout="6000"
      top
    >
      {{ formErrors }}
      <v-btn
        color="pink"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 pa-4 ma-0>
        <v-form>
          <v-text-field
            prepend-icon="person"
            name="login"
            label="Login"
            type="text"
            :error="false"
            :error-count="null"
            :error-messages="null"
            v-model="credentials.email"
          />
          <v-text-field
            prepend-icon="lock"
            name="password"
            label="Password"
            id="password"
            type="password"
            v-model="credentials.password"
            @keyup.13="login"
          />
        </v-form>
        <v-layout align-center justify-space-between row fill-height>
          <v-checkbox v-model="credentials.remember" label="Lembrar"/>
          <v-spacer />
          <v-btn
            class="pa-0"
            :loading="btnLoginLoading"
            :disabled="loginButtonDisabled"
            @click="login"
            color="primary"
            v-text="'Login'"
          />
        </v-layout>
        <!--v-layout align-center justify-center>
          Ainda não tem conta? <br/>
          <router-link to="register" v-text="'Crie uma agora'" />
        </v-layout-->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  data () {
    return {
      snackbar: false,
      credentials: {
        email: '',
        password: '',
        remember: false
      },
      btnLoginLoading: false,
      formErrors: null
    }
  },
  created () {
    if (this.isAuthenticated) return this.$router.replace(this.sendTo)
  },
  computed: {
    ...mapGetters('authentication', ['isAuthenticated']),
    sendTo: function () {
      const { path, redirect } = this.$route.query
      if (redirect !== undefined) return { path: redirect }
      if (path !== undefined) return { path: path }
      return { path: 'home' }
    },
    loginButtonDisabled: function () {
      return this.$v.credentials.$invalid
    }
  },
  methods: {
    ...mapActions('authentication', ['authenticate']),
    login: async function () {
      this.btnLoginLoading = true
      try {
        const user = await this.authenticate(this.credentials)
        user && this.$router.push(this.sendTo)
      } catch (err) {
        this.formErrors = err.message
        this.snackbar = true
        this.btnLoginLoading = false
      }
    }
  },
  validations: {
    credentials: {
      email: {
        required,
        minLength: minLength(3)
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
